var map = {
	"./euro2024.webp": 1508,
	"./euro2024_title.svg": 1509,
	"./event-sport-bg.jpg": 1510,
	"./event-sport-bg.png": 1511,
	"./home-icon-active.webp": 1512,
	"./home-icon.webp": 1513,
	"./img_bg-uefa.png": 1514,
	"./live-icon-active.webp": 1515,
	"./master-bg.webp": 1516,
	"./me-icon-active.webp": 1517,
	"./product-overview-bg.webp": 1518,
	"./promos-icon-active.webp": 1519,
	"./sponsor-icon-active.webp": 1520,
	"./uefa-icon-active.webp": 1521,
	"./uefa-icon.webp": 1522,
	"./uefa-prediction.webp": 1523,
	"./wwr-img.webp": 1524
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 206;